<div class="basicrow lessm">
    <div class="container">
        <div class="autowcont m-top">
            <div class="basicrow msidespad">
                <div class="b-title">
                    <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                        <div class="tabcell">
                            Balance
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow msidespad m-top-u-i">
                <div class="balancesptr-i refdef">
                    <label class="label-r">N&uacute;mero de Cuenta</label>
                <div class="basicrow">
                    <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f"  >
                        <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
                    </select>
                </div>
                </div>
                <div class="balancesptr-iicont">
                    <div class="balancesptr-ii text-center">
                        <span class="roboto-b">
                            Balance Pendiente
                        </span><br />
  
                        <span class="f-red f-lsemi roboto-b">
                            {{this.billBalanceField |currency}}{{this.cr}}
                        </span>
                    </div>
                    <div class="balancesptr-ii no-brd-i text-center">
                        <span class="roboto-b">
                            Su Factura Vence
                        </span><br />
  
                        <span class="f-black f-big roboto-b">
                            {{this.billDueDateField}}
                        </span>
                    </div>
                </div>
                <div class="basicrow m-bott visible-xs">
                    <div class="logline full"></div>
                </div>
                <div class="balancesptr-iv refdef f-reg roboto-r text-center">
                  <div class="roboto-b">
                    <span class="roboto-b">Fecha de Factura</span>
                    <br>
                    <span class="f-black f-big roboto-b ng-binding">{{this.billDateField}}</span>
                  </div>
                </div>
                <div class="balancesptr-iv refdef no-brd f-reg roboto-r text-center">
                  <div class="roboto-b">
                    <span class="roboto-b">Último Pago</span>
                    <br>
                    <span class="f-black f-big roboto-b ng-binding">{{this.lastPaymentAmountField|currency}}</span>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>